import { configureStore, combineReducers } from "@reduxjs/toolkit";
import loginReducer from "../slices/loginSlice";
import userProfileReducer from "../slices/userProfileSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const noopStorage = {
  getItem(_key: string) {
    return Promise.resolve(null);
  },
  setItem(_key: string, value: any) {
    return Promise.resolve(value);
  },
  removeItem(_key: string) {
    return Promise.resolve();
  },
};

const rootReducer = combineReducers({
  login: loginReducer,
  userProfile: userProfileReducer,
});

const persistConfig = {
  key: "root",
  storage: typeof window !== "undefined" ? storage : noopStorage,
  whitelist: ["login", "userProfile"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const makeStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST"],
          ignoredActionPaths: ["meta.arg", "payload.timestamp"],
          ignoredPaths: ["items.dates"],
        },
      }),
  });
};

export const store = makeStore();
export const persistor = persistStore(store);

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
